<template>
    <div class="accountinglot-search">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Registro"
                    sub="Pesquisa de Lote Contábil"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    title="Adicionar Registro"
                    @click="actionNewAccountingLot"
                    variant="dark"
                    class="mr-2 mt-2 fa fa-plus"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 fa"
                    :class="icon"
                    @click=";[loadAccountingLots(), (showTable = !showTable)]"
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Início:"
                    label-for="accountinglot-search-start_date"
                >
                    <b-form-input
                        id="accountinglot-search-start_date"
                        type="date"
                        v-model="start_date"
                        ref="inputsearch"
                        @input="loadAccountingLots"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Término:"
                    label-for="accountinglot-search-end_date"
                >
                    <b-form-input
                        id="accountinglot-search-end_date"
                        type="date"
                        v-model="end_date"
                        @input="loadAccountingLots"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="3" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="accountinglot-search-company_id"
                >
                    <b-form-select
                        id="accountinglot-search-company_id"
                        @input="loadAccountingLots"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Status:"
                    label-for="accountinglot-search-document_status_id"
                >
                    <b-form-select
                        id="accountinglot-search-document_status_id"
                        size="sm"
                        @input="loadAccountingLots"
                        :options="documentstatus"
                        v-model="document_status_id"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" sm="12">
                <template>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <transition name="slide" type="animation" appear>
                        <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            v-show="showTable"
                            hover
                            key="slide"
                            head-variant="light"
                            :items="accountinglots"
                            :fields="fieldsAccountingLot"
                        >
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Desconfirmar registro"
                                    size="sm"
                                    variant="light"
                                    v-if="
                                        data.item.accountinglot_status_id === 2
                                    "
                                    @click="
                                        showMsgBoxUnsetAccounting(data.item)
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-unlock"></i>
                                </b-button>
                                <b-button
                                    title="Editar registro"
                                    size="sm"
                                    variant="light"
                                    @click="actionEditAccountingLot(data.item)"
                                    class="mr-2 mt-2 fa fa-pencil"
                                >
                                </b-button>
                                <b-button
                                    title="Excluir registro"
                                    size="sm"
                                    variant="light"
                                    v-if="
                                        data.item.accountinglot_status_id === 1
                                    "
                                    @click=";[showMsgBoxDeleted(data.item)]"
                                    class="mr-2 mt-2 fa fa-trash"
                                >
                                </b-button>
                                <b-button
                                    title="Contabilização"
                                    size="sm"
                                    variant="light"
                                    v-if="
                                        data.item.accountinglot_status_id === 2
                                    "
                                    @click="
                                        ;[
                                            setReleaseAccount(data.item),
                                            showMsgBoxAccounting()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-exchange"></i>
                                </b-button>
                                <b-button
                                    title="Copiar Lote"
                                    size="sm"
                                    variant="light"
                                    v-if="
                                        data.item.accountinglot_status_id === 2
                                    "
                                    @click="
                                        ;[
                                            setReleaseAccount(data.item),
                                            showMsgBoxCopy()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-copy"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
        </b-row>
        <b-modal
            id="modalAccounting"
            ref="modal"
            hide-footer
            size="xl"
            title-tag="h6"
            title="Contabilização"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-table
                    class="table-responsive"
                    head-variant="dark"
                    hover
                    striped
                    :items="accountingentrys"
                    :fields="fieldsAccounting"
                >
                </b-table>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError, searchglobalkey } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
var moment = require('moment-timezone')

export default {
    name: 'AccountingLotSearch',
    components: { PageTitle },
    data: function() {
        return {
            mode: 'insert',
            modeAccountingLot: 'insert',
            start_date: null,
            end_date: null,
            document_status_id: null,
            company_id: null,
            search: '',
            searchEntity: '',
            boxCancel: '',
            accountinglot: {},
            accountinglots: [],
            documentstatus: [],
            companys: [],
            accountingentrys: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            showAccountingLot: false,
            showEntity: false,
            perPage: 5,
            currentPage: 1,
            fieldsAccountingLot: [
                { key: 'id', label: 'ID', sortable: true },
                {
                    key: 'accountinglot_date',
                    label: 'Data Lote',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'accountinglot_number',
                    label: 'Número',
                    sortable: true
                },
                {
                    key: 'name_document_status',
                    label: 'Status',
                    sortable: false
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsAccounting: [
                {
                    key: 'accounting_date',
                    label: 'Contabilizado',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'name_cost_center',
                    label: 'Centro de Resultado',
                    sortable: false
                },
                {
                    key: 'account_plan',
                    label: 'Conta',
                    sortable: false,
                    variant: 'light'
                },
                {
                    key: 'account_name_plan',
                    label: 'Descrição',
                    sortable: false,
                    variant: 'secondary'
                },
                {
                    key: 'accounting_nature_account',
                    label: 'Nat.',
                    sortable: false,
                    variant: 'light'
                },
                {
                    key: 'accounting_value',
                    label: 'Valor',
                    sortable: false,
                    variant: 'secondary'
                },
                {
                    key: 'accounting_comments',
                    label: 'Histórico',
                    sortable: false
                }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        searchglobal() {
            return this.$store.state.searchglobal
        },
        filteredListEntity() {
            return this.entitysshearch.filter(entity => {
                return entity.name_entity
                    .toLowerCase()
                    .includes(this.searchEntity.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.accountinglots.length
        }
    },
    methods: {
        showMsgBoxDeleted(accountinglot) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Excluir o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeAccountingLot(accountinglot)
                    }
                })
        },
        showMsgBoxUnsetAccounting(accountinglot) {
            this.boxAccount = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Desconfirmar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-1',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxAccount = value
                    if (this.boxAccount === true) {
                        await this.unsetconfirmAccountingLot(accountinglot)
                    }
                })
        },
        showMsgBoxAccounting() {
            this.boxAccount = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Contabilizar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-1',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxAccount = value
                    if (this.boxAccount === true) {
                        await this.reaccountingRelease()
                    }
                })
        },
        showMsgBoxCopy() {
            this.boxAccount = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Copiar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-1',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxAccount = value
                    if (this.boxAccount === true) {
                        await this.copyRelease()
                    }
                })
        },
        formatDate(date) {
            return moment
                .utc(date)
                .local()
                .format('YYYY-MM-DD')
        },
        loadEntitys() {
            const url = `${baseApiUrl}/entitys`
            axios.get(url).then(res => {
                this.entitysshearch = res.data
            })
        },
        loadAccountingLots() {
            const url = `${baseApiUrl}/accountinglotssearchdate/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&status_id=${this.accountinglot_document_status_id}`
            axios.get(url).then(res => {
                this.accountinglots = res.data
            })
        },

        async removeAccountingLot(accountinglot) {
            const id = accountinglot.id
            await axios
                .delete(`${baseApiUrl}/accountinglots/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadAccountingLots()
                })
                .catch(showError)
        },
        actionEditAccountingLot(accountinglot) {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            if (accountinglot.accountinglot_date)
                accountinglot.accountinglot_date = this.formatDate(
                    accountinglot.accountinglot_date
                )

            this.$router.push({
                name: 'RecordAccountingLot',
                params: { id: accountinglot.id },
                query: { accountinglotbase: accountinglot }
            })
        },
        async loadDocumentStaus() {
            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                this.documentstatus = res.data.map(documentstatu => {
                    return {
                        value: documentstatu.id,
                        text: documentstatu.name_document_status
                    }
                })
            })
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
            this.$refs.inputsearch.focus()
        },
        actionNewAccountingLot() {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            } else {
                const accountinglot = {}
                accountinglot.accountinglot_status_id = 1
                this.$router.push({
                    name: 'RecordAccountingLot',
                    query: { accountinglotbase: accountinglot }
                })
            }
        },
        async unsetconfirmAccountingLot(accountinglot) {
            this.accountinglot = { ...accountinglot }
            this.accountinglot.accountinglot_status_id = 1
            delete this.accountinglot.name_document_status
            delete this.accountinglot.register

            await axios['post'](
                `${baseApiUrl}/accountinglots`,
                this.accountinglot
            )
                .then(async () => {
                    await this.loadAccountingLots()
                    this.$toasted.global.defaultSuccess()
                })
                .catch(showError)
        },
        async AccountingAccountingLot(release) {
            const id = release.id
            await axios
                .get(`${baseApiUrl}/accountingentryaccountinglots/${id}`)
                .then(res => {
                    this.accountingentrys = res.data
                })
        },
        setReleaseAccount(release) {
            this.accountinglot = { ...release }
        },
        async reaccountingRelease() {
            if (this.compan.require_account_entry === 1) {
                if (this.accountinglot.accountinglot_status_id === 2) {
                    await axios['post'](
                        `${baseApiUrl}/accountinglotrelease`,
                        this.accountinglot
                    )
                        .then(async () => {
                            await this.loadAccountingLots()
                            this.$toasted.global.defaultSuccess()
                        })
                        .catch(showError)
                }
            } else {
                this.$toasted.global.defaultWarning({
                    msg:
                        'Empresa não está configurada para usar a contabilização de lançamento.'
                })
            }
        },
        async copyRelease() {
            if (this.accountinglot.accountinglot_status_id === 2) {
                await axios['post'](
                    `${baseApiUrl}/copyaccountinglots`,
                    this.accountinglot
                )
                    .then(async () => {
                        await this.loadAccountingLots()
                        this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)
            }
        }
    },
    mounted() {
        this.loadCompanys()
        this.loadDocumentStaus()
        this.showTable = true

        if (this.searchglobal) {
            this.start_date = moment(
                this.searchglobal.start_date_release
            ).format('YYYY-MM-DD')
            this.end_date = moment(this.searchglobal.end_date_release).format(
                'YYYY-MM-DD'
            )
            this.company_id = this.searchglobal.company_id_release
        } else {
            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            } else {
                this.start_date = moment()
                    .startOf('month')
                    .format('YYYY-MM-DD')
                this.end_date = moment()
                    .endOf('month')
                    .format('YYYY-MM-DD')
                this.company_id = this.compan.id
                this.loadAccountingLots()
            }
        }
    }
}
</script>

<style>
.accountinglot-search {
    font-size: 0.7rem;
}

.accountinglot-search input,
label,
form {
    font-size: 0.7rem;
}
.accountinglot-search button {
    font-size: 0.7rem;
}

.accountinglot-search select {
    font-size: 0.7rem;
}

.accountinglot-search table {
    font-size: 0.7rem;
}

#modalAccounting {
    font-size: 0.7rem;
}

#modalAccounting button {
    font-size: 0.7rem;
}
#modalAccounting input,
label,
form {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
